import { PHONE_CODES } from '../../utils/phone'

export default function PhoneFields({ register, errors, disabled = false, required = false }) {
  return (
    <div>
      <label className="block text-sm font-medium text-secondary-700 mb-2">
        Mobile number {required ? '*' : ''}
      </label>
      <div className="flex gap-2">
        <select
          {...register('phone_country')}
          className="input w-40"
          disabled={disabled}
          defaultValue="+91"
        >
          {PHONE_CODES.map((item) => (
            <option key={item.code} value={item.code}>{item.label}</option>
          ))}
        </select>
        <input
          {...register('phone_number', {
            required: required ? 'Mobile number is required' : false,
            validate: (value) => {
              if (!value) return true
              return /^\d{6,14}$/.test(value) || 'Enter the number without the country code'
            }
          })}
          type="tel"
          inputMode="numeric"
          className={`input flex-1 ${errors.phone_number ? 'border-red-500' : ''}`}
          placeholder="9876543210"
          disabled={disabled}
        />
      </div>
      {errors.phone_number && (
        <p className="mt-1 text-sm text-red-600">{errors.phone_number.message}</p>
      )}
    </div>
  )
}
